import { ICommand } from 'core-ts-types';
import * as _4 from 'lodash4';
import { APUserModeConfig } from '../../../global/components/user_mode_config/config/ap_user_mode_config';
import { IPlannedTerm } from '../../../global/helpers/ap_multi_plan_helper';

class TermBoxMmMenu {
  private term: IPlannedTerm;
  private isOpened = false;
  public popupMenuId: string;
  private isAdvisor = false;
  constructor(
    public $state: ng.ui.IStateService,
    public appConfigModel: any,
    public ngAPUserModeConfig: APUserModeConfig,
    private deleteMmTermCommand: ICommand
  ) {
    this.popupMenuId = _4.uniqueId();
  }

  $onInit() {
    this.initialize();
  }

  $onChanges() {
    this.initialize();
  }

  deleteTerm() {
    this.isOpened = true;
  }

  initialize() {
    this.isAdvisor = this.ngAPUserModeConfig.isAdvisor();
  }
}

angular.module('capability-ng-academic-planner').component('termBoxMmMenu', {
  templateUrl: 'capability-ng-academic-planner/src/plan/components/term_box_menu/term_box_mm_menu.html',
  bindings: {
    term: '<',
    isPast: '<?'
  },
  controller: TermBoxMmMenu
});



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-academic-planner/src/plan/components/term_box_menu/term_box_mm_menu.ts